<template>
  <v-dialog max-width="900" v-model="dialog">
    <v-card class="rounded-lg">
      <v-card-title>
        <v-icon class="mr-2" color="black">mdi-link-box-outline</v-icon>
        Associate to Case
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="searchForCase">
          <v-row class="mt-2">
            <v-col cols="10">
              <v-text-field
                v-model="search"
                clearable
                label="Case ID"
                outlined
                class="rounded-lg"
              />
            </v-col>
            <v-col cols="2" class="text-right">
              <v-btn class="btn-primary" x-large @click="searchForCase()">
                Search
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <div
          class="text-center my-10"
          v-if="searched && searchResults.length === 0"
        >
          No Results for: {{ search }}
        </div>
        <v-simple-table v-if="searched && searchResults.length > 0">
          <thead>
            <tr>
              <th>Case ID</th>
              <th>Client</th>
              <th>Patient Reference</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(kase, index) in searchResults"
              :key="index"
              @click="associateSession(kase)"
              style="cursor: pointer"
            >
              <td>
                <strong>{{ kase.case_mkey }}</strong>
                <br />
                <small>{{ kase.job_type }}</small>
              </td>
              <td>{{ kase.client }}</td>
              <td>{{ kase.patient_reference }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "AssociateToCase",

  props: ["value"],

  watch: {
    search(value, previousValue) {
      if (value !== previousValue) this.searched = false
    }
  },

  data() {
    return {
      search: null,
      searched: false,
      searchResults: []
    }
  },

  computed: {
    ...mapGetters(["ncSessionID"]),

    dialog: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit("input", value)
      }
    }
  },

  methods: {
    async searchForCase() {
      const response = await this.$axios.get(
        `/proxy/admin/cases/?search=${this.search}`
      )
      this.searched = true
      this.searchResults = response.data
    },

    async associateSession(kase) {
      if (!confirm("Are you sure?")) return

      await this.$axios.post(
        `/proxy/admin/cases/${kase.uid}/${this.ncSessionID}/`
      )
      this.searched = false
      this.searchResults = []
      this.dialog = true
    }
  }
}
</script>
